// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__18fZf","footer":"ReportModalFilter_footer__2nlEv"};